export default {
    shifts: { method: 'get',    url: 'shifts' },
}